import { Button } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { ReviewServices } from "../ReviewServices/ReviewServices";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReviewServicesStep(_ref) {
  let {
    selectedBundleID,
    selectedOptionalServices,
    onDone,
    onBack,
    setSelectedOptionalServices
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.reviewServices),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'review-services-step-next-btn',
      onClick: () => {
        onDone();
      },
      children: 'Next'
    }),
    errorTestid: "review-services-step-next-error",
    onBackBtnClick: onBack,
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'review-services-step-back-btn',
    testid: "review-services-step",
    children: /*#__PURE__*/_jsx(ReviewServices, {
      relationship: relationship,
      selectedBundleID: selectedBundleID,
      selectedOptionalServices: selectedOptionalServices,
      setSelectedOptionalServices: setSelectedOptionalServices
    })
  });
}